import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { SingleValueResponse } from 'app/shared/SingleValueResponse.model';
import { Observable, ReplaySubject, map, tap } from 'rxjs';

@Injectable({providedIn: 'root'})
export class NavigationService
{
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient)
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        return this._httpClient.get<SingleValueResponse<FuseNavigationItem[]>>('~user/me/navigation').pipe(
            map(resp => {
                const items = resp.result
                const result: Navigation = {
                    default: items,
                    compact: items,
                    futuristic: items,
                    horizontal: items
                }
                return result
            }),
            tap(x => {
                this._navigation.next(x)
            })
        )
    }
}
